module.exports = __webpack_public_path__ + "img/quest_icon_0012_support.82d13b78.png";